module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pb9"
  }, [_c('AppEditProductsDialog'), _vm._v(" "), _c('v-card', [_c('v-card-title', [_c('v-spacer'), _vm._v(" "), (_vm.categoriesList) ? _c('v-combobox', {
    attrs: {
      "items": _vm.categoriesList,
      "search-input": _vm.categorySearch,
      "hide-selected": "",
      "clearable": "",
      "label": "Filter by category"
    },
    on: {
      "change": _vm.filterByCategory,
      "update:searchInput": function($event) {
        _vm.categorySearch = $event
      },
      "update:search-input": function($event) {
        _vm.categorySearch = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(props) {
        return [_vm._v("\n          " + _vm._s(props.item.cascade_name) + "\n        ")]
      }
    }, {
      key: "selection",
      fn: function(props) {
        return [_vm._v("\n          " + _vm._s(props.item.cascade_name) + "\n        ")]
      }
    }], null, false, 127982300)
  }) : _vm._e()], 1), _vm._v(" "), _c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.tableHeaders,
      "items": _vm.products,
      "loading": _vm.loadingInProgress,
      "no-data-text": _vm.loadingOrNoItemsText,
      "rows-per-page-items": _vm.rowsPerPageItems,
      "pagination": _vm.pagination
    },
    on: {
      "update:pagination": function($event) {
        _vm.pagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.price))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.commission))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.amount))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.category ? props.item.category.name : 'N/A'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.user ? props.item.user.name : 'N/A'))]), _vm._v(" "), _c('td', {
          staticClass: "justify-left layout px-0"
        }, [_c('v-btn', {
          staticClass: "mx-0",
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              return _vm.editElement(props.item.id)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "teal"
          }
        }, [_vm._v("edit")])], 1), _vm._v(" "), _c('v-btn', {
          staticClass: "mx-0",
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              return _vm.deleteDialog(props.item.id)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "pink"
          }
        }, [_vm._v("delete")])], 1), _vm._v(" "), _c('confirmation-dialog', {
          ref: "confirm"
        })], 1)]
      }
    }])
  }), _vm._v(" "), _c('AddProductButton')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5433ff7c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/resources/Products.vue
// module id = 992
// module chunks = 1